import { atom } from "jotai";
import { loadCurrentUser } from "../api/AppApi";
// Atoms
export const currentUserAtom = atom(null);
export const currentUserLoadingAtom = atom(true);
export const currentUserErrorAtom = atom(null);
// Current User
export const loadCurrentUserAtom = atom((get) => get(currentUserAtom), // Getter
async (get, set) => {
    console.log("appState :: loadCurrentUserAtom :: LOADING");
    set(currentUserLoadingAtom, true);
    set(currentUserErrorAtom, null);
    try {
        console.log("appState :: loadCurrentUserAtom :: ", loadCurrentUser);
        const response = await loadCurrentUser();
        set(currentUserAtom, response.body);
    }
    catch (error) {
        const err = error;
        set(currentUserErrorAtom, err.message);
    }
    finally {
        set(currentUserLoadingAtom, false);
    }
});
